package one.healthium.onboarding.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import one.healthium.domain.user.models.bindPlaceholderValues

@Composable
internal fun String.bindPlaceholderValues(userState: UserProfileUiModel): String {
    var value by remember { mutableStateOf("") }

    LaunchedEffect(this, userState) {
        value = userState.model.bindPlaceholderValues(this@bindPlaceholderValues, userState.isMetric)
    }

    return value
}
